<template>
  <div
    class="d-flex flex-column"
    :class="
      item.url_midia_colaboracao && !isFullScreen ? 'mb-14' : !isFullScreen ? 'mb-15' : ''
    "
    :style="cardStyle"
    :key="item.id_colaboracao"
  >
    <section
      class="d-flex align-center flex-grow-1"
      :class="isFullScreen ? 'px-0' : 'px-2'"
    >
      <div v-if="renderMode === 'text'" style="width: 100%; height: 100%">
        <TextView
          :header-text="
            flgExibirUf && item.dsc_uf_colaborador
              ? `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}`
              : `${item.dsc_nome_colaborador}`
          "
          :text="item.dsc_texto_colaboracao"
          :font-size="bodyTextSize"
          :line-height="lineHeight"
        />
      </div>
      <div v-if="renderMode === 'audio'" style="width: 100%; height: 100%">
        <AudioView
          :header-text="
            flgExibirUf && item.dsc_uf_colaborador
              ? `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}`
              : `${item.dsc_nome_colaborador}`
          "
          :url-audio="item.url_midia_colaboracao"
        />
      </div>
      <div
        v-else-if="renderMode === 'midia' && !isFullScreen"
        :style="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? `width: 100%;`
            : `width: 100%; display: grid; grid-template-columns: 1fr;`
        "
        :class="
          item.dsc_tipo_midia_colaboracao === 'image'
            ? 'd-flex align-center justify-center pa-2 mt-2 mb-1'
            : 'pa-2 mt-2 mb-1'
        "
        :id="`${item.id_colaboracao}-wrapper`"
      >
        <MidiaView
          v-if="midiaOrientation === 'horizontal'"
          :header-text="
            flgExibirUf && item.dsc_uf_colaborador
              ? `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}`
              : `${item.dsc_nome_colaborador}`
          "
          :midia-type="item.dsc_tipo_midia_colaboracao"
          :midia-url="item.url_midia_colaboracao"
          :midia-size="{
            width: (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20,
            height: (percentScreenDim.maxHeight * screenDimensions.height) / 100 - 100,
          }"
        />
        <MidiaVerticalView
          v-else
          :header-text="
            flgExibirUf && item.dsc_uf_colaborador
              ? `${item.dsc_nome_colaborador} -
            ${item.dsc_uf_colaborador}`
              : `${item.dsc_nome_colaborador}`
          "
          :midia-type="item.dsc_tipo_midia_colaboracao"
          :midia-url="item.url_midia_colaboracao"
          :midia-size="{
            width: (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20,
            height: (percentScreenDim.maxHeight * screenDimensions.height) / 100,
          }"
        />
      </div>
      <div v-else-if="renderMode === 'midia_texto'">
        <MidiaHorizontalTextView
          v-if="midiaOrientation === 'horizontal'"
          :header-text="
            flgExibirUf && item.dsc_uf_colaborador
              ? `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}`
              : `${item.dsc_nome_colaborador}`
          "
          :text="item.dsc_texto_colaboracao"
          :line-height="lineHeight"
          :font-size="bodyTextSize"
          :midia-type="item.dsc_tipo_midia_colaboracao"
          :midia-url="item.url_midia_colaboracao"
          :midia-size="{
            width: (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20,
            height: (percentScreenDim.maxHeight * screenDimensions.height) / 100 - 100,
          }"
        />
        <MidiaVerticalTextView
          v-else
          :header-text="
            flgExibirUf && item.dsc_uf_colaborador
              ? `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}`
              : `${item.dsc_nome_colaborador}`
          "
          :text="item.dsc_texto_colaboracao"
          :line-height="lineHeight"
          :font-size="bodyTextSize"
          :midia-type="item.dsc_tipo_midia_colaboracao"
          :midia-url="item.url_midia_colaboracao"
          :midia-size="{
            width: (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20,
            height: (percentScreenDim.maxHeight * screenDimensions.height) / 100 - 100,
          }"
        />
      </div>
      <div
        style="width: 100%; height: 100%"
        v-if="(renderMode = 'midia' && isFullScreen)"
      >
        <MidiaHorizontalTelaCheia
          v-if="midiaOrientation === 'horizontal'"
          :header-text="
            flgExibirUf && item.dsc_uf_colaborador
              ? `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}`
              : `${item.dsc_nome_colaborador}`
          "
          :midia-type="item.dsc_tipo_midia_colaboracao"
          :midia-url="item.url_midia_colaboracao"
          :midia-size="{
            width: (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20,
            height: (percentScreenDim.maxHeight * screenDimensions.height) / 100 - 100,
          }"
        />
        <MidiaVerticalTelaCheia
          v-else
          :header-text="
            flgExibirUf && item.dsc_uf_colaborador
              ? `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}`
              : `${item.dsc_nome_colaborador}`
          "
          :midia-type="item.dsc_tipo_midia_colaboracao"
          :midia-url="item.url_midia_colaboracao"
          :midia-size="{
            width: (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20,
            height: (percentScreenDim.maxHeight * screenDimensions.height) / 100 - 100,
          }"
        />
      </div>
    </section>
  </div>
</template>

<script>
import AudioView from "../Tarjas/PanelaSportv/AudioView.vue";
import MidiaHorizontalTelaCheia from "../Tarjas/PanelaSportv/MidiaHorizontalTelaCheia.vue";
import MidiaHorizontalTextView from "../Tarjas/PanelaSportv/MidiaHorizontalTextView.vue";
import MidiaVerticalTelaCheia from "../Tarjas/PanelaSportv/MidiaVerticalTelaCheia.vue";
import MidiaVerticalTextView from "../Tarjas/PanelaSportv/MidiaVerticalTextView.vue";
import MidiaVerticalView from "../Tarjas/PanelaSportv/MidiaVerticalView.vue";
import MidiaView from "../Tarjas/PanelaSportv/MidiaView.vue";
import TextView from "../Tarjas/PanelaSportv/TextView.vue";

const pathBgTarjaGe = require("../../assets/tarjas/bg-tarja-ge.png");

export default {
  props: {
    item: Object,
    posicaoCard: String,
    isFullScreen: Boolean,
    hideUserInfo: Boolean,
    flgExibirUf: Boolean,
  },
  components: {
    TextView,
    AudioView,
    MidiaView,
    MidiaVerticalView,
    MidiaHorizontalTextView,
    MidiaVerticalTextView,
    MidiaHorizontalTelaCheia,
    MidiaVerticalTelaCheia,
  },
  data() {
    return {
      midiaOrientation: null,
      midiaDimension: {},
      divMidiaWrapperDimension: null,
      percentScreenDim: {
        // porcentagem da tela que a div irá ocupar
        maxWidth: 30,
        minWidth: 20,
        minHeight: 40,
        maxHeight: 70,
        fullScreenMaxWidth: 100,
        fullScreenMaxHeight: 100,
        fullScreenMinWidth: 100,
        fullScreenMinHeight: 100,
      },
    };
  },
  created() {
    // this.pathBgTarjaGe = require("../../assets/tarjas/bg-tarja-ge.png");
    if (this.item.url_midia_colaboracao) {
      this.getMidiaOrientation();
    }
  },
  computed: {
    midiaBg() {
      const backgroundStyle = `background-image: url(${pathBgTarjaGe}); background-repeat: round; background-size: cover`;
      return backgroundStyle;
    },
    renderMode() {
      if (
        this.item.dsc_tipo_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "audio"
      ) {
        return "audio";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        (!this.item.dsc_texto_colaboracao || !this.item.flg_exibir_texto)
      ) {
        return "midia";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.item.dsc_texto_colaboracao &&
        this.isFullScreen
      ) {
        return "midia_texto_fullscreen";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.item.flg_exibir_texto &&
        this.item.dsc_texto_colaboracao &&
        !this.isFullScreen
      ) {
        return "midia_texto";
      } else if (
        this.item.dsc_texto_colaboracao &&
        this.isFullScreen &&
        !this.url_midia_colaboracao
      ) {
        return "texto_fullscreen";
      }
      return "text";
    },
    bodyTextSize() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "2.1rem"
          : numChars > 40 && numChars <= 80
          ? "1.7rem"
          : numChars > 80 && numChars <= 120
          ? "1.6rem"
          : numChars > 120 && numChars <= 160
          ? "1.5rem"
          : numChars > 160 && numChars <= 200
          ? "1.4rem"
          : numChars > 200 && numChars <= 240
          ? "1.3rem"
          : numChars > 240 && numChars <= 280
          ? "1.2rem"
          : "1.5rem";
      return size;
    },
    lineHeight() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "2.2rem"
          : numChars > 40 && numChars <= 80
          ? "1.9rem"
          : numChars > 80 && numChars <= 120
          ? "1.8rem"
          : numChars > 120 && numChars <= 160
          ? "1.7rem"
          : numChars > 160 && numChars <= 200
          ? "1.6rem"
          : numChars > 200 && numChars <= 240
          ? "1.5rem"
          : numChars > 240 && numChars <= 280
          ? "1.4rem"
          : "1.5rem";

      return lineHeight;
    },
    bodyTextSizeFullSreen() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "2.7rem"
          : numChars > 80 && numChars <= 120
          ? "2.5rem"
          : numChars > 120 && numChars <= 160
          ? "2.4rem"
          : numChars > 160 && numChars <= 200
          ? "2.2rem"
          : numChars > 200 && numChars <= 240
          ? "2.1rem"
          : numChars > 240 && numChars <= 280
          ? "2.5rem"
          : "1.5rem";
      return size;
    },
    lineHeightFullScreen() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "2.8rem"
          : numChars > 80 && numChars <= 120
          ? "2.6rem"
          : numChars > 120 && numChars <= 160
          ? "2.5rem"
          : numChars > 160 && numChars <= 200
          ? "2.4rem"
          : numChars > 200 && numChars <= 240
          ? "2.3rem"
          : numChars > 240 && numChars <= 280
          ? "2.8rem"
          : "1.5rem";

      return lineHeight;
    },
    screenDimensions() {
      return {
        width: this.$vuetify.breakpoint.width,
        height: this.$vuetify.breakpoint.height,
      };
    },
    // backgroundColor() {
    //   return this.configCores.dsc_hex_cor_background;
    // },
    // bodyTextColor() {
    //   return this.configCores.dsc_hex_cor_texto;
    // },
    // headerInfoColor() {
    //   return this.configCores.dsc_hex_cor_header;
    // },
    cardStyle() {
      let maxWidth, maxHeight, minWidth, minHeight;
      if (this.isFullScreen) {
        minWidth =
          (this.percentScreenDim.fullScreenMinWidth * this.screenDimensions.width) / 100; // 20% of screen width + 20px
        maxWidth =
          (this.percentScreenDim.fullScreenMaxWidth * this.screenDimensions.width) / 100; // 60% of screen width + 20px
        minHeight =
          (this.percentScreenDim.fullScreenMinHeight * this.screenDimensions.height) /
          100; // 60% of screen height + 50px
        maxHeight =
          (this.percentScreenDim.fullScreenMaxHeight * this.screenDimensions.height) /
          100; // 80% of screen height + 50px
        // if (this.renderMode === "texto_fullscreen") {
        //   minWidth =
        //     (this.percentScreenDim.fullScreenMinWidth -
        //       10 * this.screenDimensions.width) /
        //     100;
        //   minHeight =
        //     (this.percentScreenDim.fullScreenMinHeight -
        //       30 * this.screenDimensions.height) /
        //     100;
        // }
        const fullScreenStyle = `justify-self: center; max-width: ${maxWidth}px !important; max-height: ${maxHeight}px !important;
                                             min-width: ${minWidth}px !important; min-height: ${minHeight}px !important; 
                                            `;
        return fullScreenStyle;
      }
      const position =
        this.posicaoCard === "esquerda" && !this.item.url_midia_colaboracao
          ? "margin-left: 150px; justify-self: flex-start"
          : this.posicaoCard === "centro"
          ? "justify-self: center"
          : this.posicaoCard === "direita" && !this.item.url_midia_colaboracao
          ? "margin-right: 40px; justify-self: flex-end"
          : this.posicaoCard === "direita" && this.item.url_midia_colaboracao
          ? "margin-right: 60px; justify-self: flex-start"
          : this.posicaoCard === "esquerda" && this.item.url_midia_colaboracao
          ? "margin-left: 120px; justify-self: flex-start"
          : "";

      // regras para visualização normal, sem modo tela cheia
      maxWidth = (this.percentScreenDim.maxWidth * this.screenDimensions.width) / 100; // 40% of screen width
      maxHeight = (this.percentScreenDim.maxHeight * this.screenDimensions.height) / 100; // 80% of screen height
      // const textMaxWidth = (33.5 * this.screenDimensions.width) / 100; // 40% of screen width
      // const textMaxHeight = (15.5 * this.screenDimensions.height) / 100; // 20% of screen height)
      const dimensions =
        ["video", "image"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        !this.item.dsc_texto_colaboracao
          ? `max-width: ${maxWidth}px; max-height: ${maxHeight}px !important;`
          : this.item.url_midia_colaboracao &&
            this.item.dsc_texto_colaboracao &&
            this.midiaOrientation === "horizontal"
          ? `max-width: ${maxWidth}px; max-height: ${maxHeight}px !important;`
          : this.item.url_midia_colaboracao &&
            this.item.dsc_texto_colaboracao &&
            this.midiaOrientation === "vertical"
          ? `max-width: auto !important; max-height: ${maxHeight}px !important;`
          : `width: 640px; height: 160px;`;

      let array = position
        .split(";")
        .concat(dimensions.split(";"))
        .filter((item) => item != "");
      return array.filter((item) => item).join(";");
    },
  },
  methods: {
    getDivMidiaWrapperDimension() {
      if (
        this.item.url_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "video"
      ) {
        const item = document.getElementById(`${this.item.id_colaboracao}`);
        return { width: item.offsetWidth, height: item.offsetHeight };
      }
      return null;
    },
    getMidiaOrientation() {
      if (this.item.url_midia_colaboracao) {
        if (this.item.dsc_tipo_midia_colaboracao === "image") {
          const image = new Image();
          image.src = this.item.url_midia_colaboracao;
          image.onload = () => {
            this.midiaDimension = { width: image.width, height: image.height };
            this.midiaOrientation =
              image.height > image.width ? "vertical" : "horizontal";
          };
        } else if (this.item.dsc_tipo_midia_colaboracao === "video") {
          const createdVideoElement = document.createElement("video");
          createdVideoElement.src = this.item.url_midia_colaboracao;
          createdVideoElement.style.visibility = "hidden";
          document.body.appendChild(createdVideoElement);
          createdVideoElement.addEventListener("loadedmetadata", () => {
            this.midiaDimension = {
              width: createdVideoElement.videoWidth,
              height: createdVideoElement.videoHeight,
            };
            this.midiaOrientation =
              createdVideoElement.videoHeight > createdVideoElement.videoWidth
                ? "vertical"
                : "horizontal";
            document.body.removeChild(createdVideoElement);
          });
        }
      }
    },
  },
  watch: {
    item: function (newValue) {
      if (newValue.url_midia_colaboracao) {
        this.getMidiaOrientation();
        this.divMidiaWrapperDimension = this.getDivMidiaWrapperDimension();
      }
    },
    cardStyle() {
      this.getMidiaOrientation();
      this.divMidiaWrapperDimension = this.getDivMidiaWrapperDimension();
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Aku&Kamu";
  src: url("@/assets/Aku&Kamu.otf") format("opentype");
}

header {
  //   width: 100%;
}

.headerText {
  font-family: "Globotipo Texto" !important;
  font-weight: bold;
}

section {
  width: 100%;
}

@media only screen and (max-width: 1367px) and (max-height: 769px) {
  // .colab-text {
  //     font-size: calc(v-bind('bodyTextSize') - .0rem) !important;
  //     line-height: calc(v-bind('lineHeight') - .2rem) !important;
  //     // color: red !important;
  // }
}
</style>
